import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import BootstrapVue from 'bootstrap-vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.use(BootstrapVue)